import React, { Component } from "react";
import { Button, Form, Input, Modal, Row } from "antd";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setkeyboardEnabled } from "../../../actions/AppAction";
import { sendShareAssets } from "../../../actions/AssetsShareAction";
import { getNewPermission, sendNotification } from "../../../utils/index";
import { editFolder } from "../../../actions/ClientAction";
import { cleanDataBackRoot, getRoot } from "../../../actions/AssetsRootAction";
import { getExplore } from "../../../actions/AssetsExploreAction";
import "./RenameModal.css";

class RenameModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oldName: props.selectedFile.name,
      newName: ""
    };
  }

  handleNewNameChanged = e => {
    this.setState({
      newName: e.target.value
    });
  };

  handleOnEdit = () => {
    const { workclient, selectedFile, user, newMatrix, intl } = this.props;

    const { newName } = this.state;

    console.log("Rename Modal");
    const canEditFolder =
      user.clientRole !== "admin" && user.role !== "admin"
        ? getNewPermission(selectedFile._id, newMatrix, "editFolder")
        : true;

    if (!canEditFolder) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "permission_denied" })
      );
      return;
    }
    if (newName.length === 0) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "rename-modal-empty" })
      );
      return;
    }

    this.props.editFolder(
      workclient,
      selectedFile._id,
      newName,
      null,
      null,
      undefined,
      undefined,
      this.handleOnHideModal
    );
  };

  handleOnHideModal = () => {
    const { intl, workclient, root } = this.props;
    sendNotification(
      "success",
      intl,
      intl.formatMessage({ id: "rename-modal-success" })
    );
    const location = this.props.history.location.pathname;
    if (!location.includes("explore")) {
      this.props.cleanDataBackRoot();
      // this.props.getRoot(workclient, root)
      this.props.getRoot(workclient, root, true, [], 1, 40);
      this.props.handleHiddenModal();
      return;
    }
    const folderId = location.split("/").pop();
    if (!folderId) return;
    this.props.handleHiddenModal();
    this.props.getExplore(workclient, folderId, 1, null, true, [], 40);
  };

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      selectedFile,
      isInFolderAction
    } = this.props;

    const { newName, oldName } = this.state;

    const isBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    const prefix = isBunker ? "" : "_file";

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="rename-modal"
      >
        <div className="rename-modal-title">
          {intl.formatMessage({ id: "rename" })}
        </div>

        <Form>
          <p className="rename-modal-label">
            {intl.formatMessage({ id: `rename-modal-label1${prefix}` })}
          </p>
          <Input
            placeholder={intl.formatMessage({
              id: `rename-modal-input1${prefix}`
            })}
            value={oldName}
            onChange={this.handleOnInputChange}
            className="rename-modal-input rename-folder"
            contentEditable={false}
            disabled
          />
          <br />
          <p className="rename-modal-label">
            {intl.formatMessage({ id: `rename-modal-label2${prefix}` })}
          </p>
          <Input
            placeholder={intl.formatMessage({
              id: `rename-modal-input2${prefix}`
            })}
            value={newName}
            onChange={this.handleNewNameChanged}
            className="rename-modal-input target-folder"
            maxLength={75}
          />
          <p className="rename-modal-counter">{`${newName.length}/75`}</p>
        </Form>

        <Row type={"flex"} justify={"space-between"}>
          <Button
            size={"large"}
            type={"primary"}
            onClick={this.handleOnEdit}
            loading={isInFolderAction}
            className="rename-modal-button accept"
          >
            {intl.formatMessage({ id: "rename" })}
          </Button>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="rename-modal-button cancel"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFile: state.individualSelect.selectedFile,
    workclient: state.client.data ? state.client.data._id : null,
    isInFolderAction: state.client.isInFolderAction,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    root: state.client.root,
    limit: state.assetsExplore.limit
  };
};

const mapDispatchToProps = {
  setkeyboardEnabled,
  sendShareAssets,
  editFolder,
  getRoot,
  cleanDataBackRoot,
  getExplore
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RenameModal))
);
